import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { OFFER_LINE, OFFER_SUMMARY, OFFER_HEADING, OFFER_TERMS, OFFER_URL } from "../content/stagingOffer";

const NAVY = "#0F2A5B";
const BLUE = "#2F6BFF";
const MUTED = "#51607A";

const Icon = () => (
  <span style={{ display: "grid", placeItems: "center", flexShrink: 0, width: 40, height: 40, borderRadius: "50%", background: `linear-gradient(145deg,${BLUE},#1D52D6)`, color: "#fff", boxShadow: "0 4px 10px rgba(47,107,255,0.35)" }}>
    <Sparkles size={20} strokeWidth={2.2} />
  </span>
);

// Compact line: OFFER_LINE + OFFER_SUMMARY underneath + "Offer details" link.
export const StagingOfferLine = ({ testId = "staging-offer-line" }) => (
  <div className="staging-offer" data-testid={testId} style={{ display: "flex", alignItems: "flex-start", gap: 12, maxWidth: 560, width: "100%", background: "#fff", border: "1px solid rgba(15,42,91,0.12)", borderRadius: 16, padding: "14px 16px", boxShadow: "0 4px 18px rgba(15,42,91,0.08)", textAlign: "left" }}>
    <Icon />
    <span>
      <span style={{ display: "block", fontSize: 15, fontWeight: 600, color: NAVY, lineHeight: 1.35 }}>{OFFER_LINE}</span>
      <span style={{ display: "block", fontSize: 13, color: MUTED, lineHeight: 1.45, marginTop: 3 }}>{OFFER_SUMMARY}</span>
      <Link to={OFFER_URL} data-testid="staging-offer-line-details" style={{ display: "inline-block", marginTop: 6, fontSize: 13, fontWeight: 600, color: BLUE, textDecoration: "none" }}>Offer details →</Link>
    </span>
  </div>
);

// Panel: OFFER_LINE + OFFER_SUMMARY + accessible <details> with full terms.
// Native <details>/<summary> is keyboard-operable and keeps the terms text in
// the HTML when collapsed (visually hidden, still in the DOM).
export const StagingOfferPanel = ({ testId = "staging-offer-panel" }) => (
  <div className="staging-offer" id="staging-offer" data-testid={testId} style={{ maxWidth: 620, width: "100%", background: "#fff", border: "1px solid rgba(15,42,91,0.12)", borderRadius: 16, padding: "16px 18px", boxShadow: "0 4px 18px rgba(15,42,91,0.08)", textAlign: "left", marginTop: 16 }}>
    <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
      <Icon />
      <span>
        <span style={{ display: "block", fontSize: 15, fontWeight: 600, color: NAVY, lineHeight: 1.35 }}>{OFFER_LINE}</span>
        <span style={{ display: "block", fontSize: 13, color: MUTED, lineHeight: 1.45, marginTop: 3 }}>{OFFER_SUMMARY}</span>
      </span>
    </div>
    <details style={{ marginTop: 12 }}>
      <summary data-testid="staging-offer-summary" style={{ cursor: "pointer", fontSize: 13, fontWeight: 600, color: BLUE }}>Offer details</summary>
      <div style={{ marginTop: 10 }}>
        <h3 style={{ fontSize: 15, fontWeight: 700, color: NAVY, margin: "0 0 8px" }}>{OFFER_HEADING}</h3>
        <ol style={{ margin: 0, paddingLeft: 18, display: "flex", flexDirection: "column", gap: 8 }}>
          {OFFER_TERMS.map((term, i) => (
            <li key={i} style={{ fontSize: 13, color: "#374151", lineHeight: 1.5 }}>{term}</li>
          ))}
        </ol>
        <Link to={OFFER_URL} data-testid="staging-offer-panel-full" style={{ display: "inline-block", marginTop: 12, fontSize: 13, fontWeight: 600, color: BLUE, textDecoration: "none" }}>Full offer details →</Link>
      </div>
    </details>
  </div>
);
